import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  FaCar, FaEdit, FaTrash, FaPlus, FaSearch, FaUser, FaArrowLeft, FaLock, FaLockOpen,
  FaFileAlt, FaTimes, FaUpload, FaFile, FaDownload, FaExchangeAlt, FaInfoCircle 
} from 'react-icons/fa'; import { cpf, cnpj } from '@fnando/cpf';
import InputMask from 'react-input-mask';
import CpfCnpjInput from '../components/CpfCnpjInput';
import DocumentButton from '../components/DocumentButton';
import BotaoProcessos from '../components/BotaoProcessos';
import Header from '../others/Header';
import config from '../config/config';
import { useNavigate, useLocation } from 'react-router-dom';
import { useToast } from '../components/ToastContext';
import ConfirmModal from '../components/ConfirmModal';
import { consultarCnpj } from '../others/consultaCnpj';
import ImportarDocumento from '../components/ImportarDocumento';
import { anexarDocumentoCliente, anexarDocumentoVeiculo } from '../others/anexos';
import { resolverAnexo, excedeLimiteDeAnexo, TAMANHO_MAXIMO_ANEXO_MB } from '../others/importacao';
import { abrirFichaCliente } from '../others/fichaCliente';
import { documentoValido as validarCpfCnpj } from '../others/documentoFiscal';
import { buscarVeiculoPorPlaca, buscarVeiculoPorChassi } from '../others/cadastroSync';


const PLACA_JA_DO_CLIENTE = 'Este veículo já está cadastrado neste cliente';
const MENSAGEM_ARQUIVO_GRANDE = `Arquivo muito grande. O tamanho máximo permitido é ${TAMANHO_MAXIMO_ANEXO_MB}MB.`;

function Clientes() {
  const { API_BASE_URL } = config;
  const [formCliente, setFormCliente] = useState({
    idCliente: null,
    nome: '',
    cpfCnpj: '',
    email: '',
    telefone: '',
    rg: '',
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    uf: '',
    ativo: true
  });
  const [buscandoCep, setBuscandoCep] = useState(false);
  const [buscandoCnpj, setBuscandoCnpj] = useState(false);
  const [importacao, setImportacao] = useState(null); // documento importado; o arquivo é anexado ao cliente ao salvar
  // Verdadeiro quando a última checagem achou outro cliente com o mesmo CPF/CNPJ (a validação ao salvar usa isto)
  const cpfDuplicadoRef = useRef(false);
  const [veiculoJaDoCliente, setVeiculoJaDoCliente] = useState(null); // veículo de mesma placa que já é deste cliente
  const [dadosImportadosVeiculo, setDadosImportadosVeiculo] = useState(null); // o que foi lido do CRLV/ATPV
  const [importacaoVeiculo, setImportacaoVeiculo] = useState(null); // CRLV/ATPV importado, anexado ao veículo ao salvar

  // Dentro do componente Clientes:
  const navigate = useNavigate();
  const location = useLocation();
  const [showBackButton, setShowBackButton] = useState(false);
  const { addToast } = useToast(); // Use o hook


  const handleBackToOS = () => {
    const redirectOrigin = localStorage.getItem('redirectAfterClientCreation');
    localStorage.removeItem('redirectAfterClientCreation');
    localStorage.removeItem('clienteSearchTerm');
    localStorage.removeItem('veiculoPlaca');

    navigate(redirectOrigin, {
      state: { clienteSelecionado }
    });
  };

  const [formVeiculo, setFormVeiculo] = useState({
    idVeiculo: null,
    placa: '',
    marcaModelo: '',
    cor: '',
    ano: '',
    observacao: '',
    renavam: '',
    chassi: '',
    motor: '',

    licenciamentos: []
  });

  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [modalVeiculoAberto, setModalVeiculoAberto] = useState(false);
  const [modalPesquisaAberto, setModalPesquisaAberto] = useState(false);
  // Busca exclusiva por placa ou chassi: acha o veículo, abre o dono e destaca o veículo na lista dele
  const [modalPlacaAberto, setModalPlacaAberto] = useState(false);
  const [termoPlaca, setTermoPlaca] = useState('');
  const [veiculoAchado, setVeiculoAchado] = useState(undefined); // undefined = não buscou; null = não achou
  const [veiculoDestacado, setVeiculoDestacado] = useState(null);
  const [veiculoEditando, setVeiculoEditando] = useState(null);
  const [termoPesquisa, setTermoPesquisa] = useState('');
  const [resultadosPesquisa, setResultadosPesquisa] = useState([]);
  const [modoEdicao, setModoEdicao] = useState(false);
  const [licenciamentos, setLicenciamentos] = useState([]);
  const [novoLicenciamento, setNovoLicenciamento] = useState('');
  const [showFileModal, setShowFileModal] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [carregandoCliente, setCarregandoCliente] = useState(false);
  const [veiculoArquivos, setVeiculoArquivos] = useState(null); // Veículo selecionado para gerenciar arquivos
  const [placaATransferir, setPlacaATransferir] = useState(null);
  const [showClienteFileModal, setShowClienteFileModal] = useState(false);
  const [clienteFiles, setClienteFiles] = useState([]);
  const [selectedClienteFile, setSelectedClienteFile] = useState(null);
  const [uploadClienteProgress, setUploadClienteProgress] = useState(0);
  const [isUploadingCliente, setIsUploadingCliente] = useState(false);
  const [uploadClienteError, setUploadClienteError] = useState(null);

  // Funções para documentos do cliente
const handleClienteFileUpload = (e) => {
  const arquivo = e.target.files[0];
  // Recusa já na escolha, antes de enviar: o servidor recusaria de qualquer forma
  if (excedeLimiteDeAnexo(arquivo)) {
    e.target.value = '';
    setSelectedClienteFile(null);
    setUploadClienteError(MENSAGEM_ARQUIVO_GRANDE);
    return;
  }
  setSelectedClienteFile(arquivo);
  setUploadClienteError(null);
};

const handleClienteUpload = async () => {
  if (!selectedClienteFile || !clienteSelecionado) return;

  const token = localStorage.getItem('jwtToken');
  setIsUploadingCliente(true);
  setUploadClienteProgress(0);
  setUploadClienteError(null);

  const formData = new FormData();
  formData.append('file', selectedClienteFile);
  formData.append('idCliente', clienteSelecionado.idCliente);

  try {
    await axios.post(`${API_BASE_URL}/arquivos/upload-cliente`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setUploadClienteProgress(percentCompleted);
      }
    });

    fetchClienteFiles(clienteSelecionado.idCliente);
    setSelectedClienteFile(null);
  } catch (error) {
    const errorMessage = getErrorMessage(error);
    setUploadClienteError(errorMessage);
    console.error('Erro no upload do cliente:', error);
  } finally {
    setIsUploadingCliente(false);
  }
};

const fetchClienteFiles = async (clienteId) => {
  const token = localStorage.getItem('jwtToken');

  try {
    const response = await axios.get(`${API_BASE_URL}/arquivos/cliente/${clienteId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    setClienteFiles(response.data);
  } catch (error) {
    console.error('Erro ao carregar arquivos do cliente:', error);
  }
};

const handleClienteDownload = async (fileId, fileName) => {
  const token = localStorage.getItem('jwtToken');

  try {
    const response = await axios.get(`${API_BASE_URL}/arquivos/download/${fileId}`, {
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error('Erro ao baixar arquivo do cliente:', error);
    addToast('error', 'Erro ao baixar arquivo. Tente novamente.');
  }
};

const handleClienteDelete = async (fileId) => {
  showConfirm(
    'Tem certeza que deseja excluir este documento do cliente?',
    async () => {
      try {
        await axios.delete(`${API_BASE_URL}/arquivos/${fileId}`, getAuthHeader());
        fetchClienteFiles(clienteSelecionado.idCliente);
        addToast('success', 'Documento excluído com sucesso!');
      } catch (error) {
        console.error('Erro ao excluir arquivo do cliente:', error);
        addToast('error', 'Erro ao excluir arquivo');
      }
    },
    'Excluir Documento do Cliente'
  );
};

const ClienteDocumentButton = ({ cliente, onClick, fileCount }) => {
  return (
    <button
      onClick={onClick}
      style={{
        padding: '8px 12px',
        backgroundColor: '#9b59b6',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '13px',
        fontWeight: '600',
        transition: 'background-color 0.3s',
        position: 'relative',
        '&:hover': {
          backgroundColor: '#8e44ad'
        }
      }}
      title="Gerenciar documentos do cliente"
    >
      <FaFileAlt />
      Documentos
      {fileCount > 0 && (
        <span style={{
          position: 'absolute',
          top: '-8px',
          right: '-8px',
          backgroundColor: '#e74c3c',
          color: 'white',
          borderRadius: '50%',
          width: '20px',
          height: '20px',
          fontSize: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold'
        }}>
          {fileCount}
        </span>
      )}
    </button>
  );
};

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    message: '',
    onConfirm: () => { },
    title: 'Confirmação',
    confirmText: 'Excluir'
  });

  // Função para mostrar confirmação
  const showConfirm = (message, onConfirm, title = 'Confirmação', confirmText = 'Excluir') => {
    setConfirmModal({
      isOpen: true,
      message,
      onConfirm,
      title,
      confirmText
    });
  };

  // Função para fechar o modal
  const closeConfirm = () => {
    setConfirmModal({
      isOpen: false,
      message: '',
      onConfirm: () => { },
      title: 'Confirmação'
    });
  };

  // Verifica se veio de uma redirecionamento
  useEffect(() => {
    const redirectOrigin = localStorage.getItem('redirectAfterClientCreation');
    const placaVeiculo = localStorage.getItem('veiculoPlaca');
    const clienteState = location.state?.clienteSelecionado;

    setShowBackButton(!!redirectOrigin);

    if (clienteState) {
      setCarregandoCliente(true);

      const carregarClienteCompleto = async () => {
        try {
          const response = await axios.get(
            `${API_BASE_URL}/clientes/${clienteState.idCliente}`,
            getAuthHeader()
          );

          setClienteSelecionado(response.data);
          setModoEdicao(true);

          fetchClienteFiles(response.data.idCliente);

          if (placaVeiculo) {
            setFormVeiculo({
              placa: placaVeiculo,
              // ... outros campos
            });
            setModalVeiculoAberto(true);
            localStorage.removeItem('veiculoPlaca');
          }
        } catch (error) {
          console.error('Erro ao carregar cliente:', error);
        } finally {
          setCarregandoCliente(false);
        }
      };

      carregarClienteCompleto();
    }
  }, [location.state]);

  const handleFileUpload = (e) => {
    const arquivo = e.target.files[0];
    if (excedeLimiteDeAnexo(arquivo)) {
      e.target.value = '';
      setSelectedFile(null);
      setUploadError(MENSAGEM_ARQUIVO_GRANDE);
      return;
    }
    setSelectedFile(arquivo);
    setUploadError(null);
  };
  const getErrorMessage = (error) => {
    if (!error.response) {
      return "Erro de conexão com o servidor. Verifique sua internet.";
    }

    const status = error.response.status;
    const data = error.response.data;

    switch (status) {
      case 400:
        // O upload responde o motivo como texto (ex.: espaço de armazenamento esgotado, tipo não permitido)
        if (typeof data === 'string' && data.trim()) return data;
        return data?.message || "Dados inválidos enviados ao servidor.";
      case 401:
        return "Sessão expirada. Faça login novamente.";
      case 403:
        return "Você não tem permissão para esta ação.";
      case 404:
        return "Recurso não encontrado.";
      case 413:
        return MENSAGEM_ARQUIVO_GRANDE;
      case 415:
        return "Tipo de arquivo não suportado. Use PDF, JPG, PNG.";
      case 500:
        return "Erro interno no servidor. Tente novamente mais tarde.";
      default:
        return data.message || "Ocorreu um erro inesperado.";
    }
  };


  const handleUpload = async () => {
    if (!selectedFile || !veiculoArquivos) return;

    const token = localStorage.getItem('jwtToken');
    setIsUploading(true);
    setUploadProgress(0);
    setUploadError(null);

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('idVeiculo', veiculoArquivos.idVeiculo); // Agora usa idVeiculo

    try {
      await axios.post(`${API_BASE_URL}/arquivos/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted);
        }
      });

      fetchFiles(veiculoArquivos.idVeiculo);
      setSelectedFile(null);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setUploadError(errorMessage);

      // Log detalhado para desenvolvimento
      console.error('Erro no upload:', {
        status: error.response?.status,
        message: error.response?.data?.message,
        error: error
      });
    } finally {
      setIsUploading(false);
    }
  };

  const handleDownload = async (fileId, fileName) => {
    const token = localStorage.getItem('jwtToken');

    try {
      const response = await axios.get(`${API_BASE_URL}/arquivos/download/${fileId}`, {
        responseType: 'blob',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Erro ao baixar arquivo:', error);
      addToast('error', 'Erro ao baixar arquivo. Tente novamente.');
    }
  };


  const handleDelete = async (fileId) => {
    showConfirm(
      'Tem certeza que deseja excluir este documento?',
      async () => {
        try {
          await axios.delete(`${API_BASE_URL}/arquivos/${fileId}`, getAuthHeader());
          fetchFiles(veiculoArquivos.idVeiculo);
          addToast('success', 'Documento excluído com sucesso!');
        } catch (error) {
          console.error('Erro ao excluir arquivo:', error);
          addToast('error', 'Erro ao excluir arquivo');
        }
      },
      'Excluir Documento'
    );
  };

  const fetchFiles = async (veiculoId) => {
    const token = localStorage.getItem('jwtToken');

    try {
      const response = await axios.get(`${API_BASE_URL}/arquivos/veiculo/${veiculoId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setFiles(response.data);
    } catch (error) {
      console.error('Erro ao carregar arquivos:', error);
    }
  };

  const handleAdicionarLicenciamentoLocal = () => {
    if (!novoLicenciamento) return;

    // Garante que licenciamentos existe e é um array
    const currentLicenciamentos = Array.isArray(formVeiculo.licenciamentos)
      ? formVeiculo.licenciamentos
      : [];

    setFormVeiculo(prev => ({
      ...prev,
      licenciamentos: [
        ...currentLicenciamentos,
        { ano: novoLicenciamento, id: Date.now() }
      ]
    }));
    setNovoLicenciamento('');
  };



  // Carregar licenciamentos quando o veículo for selecionado
  useEffect(() => {
    if (veiculoEditando?.id) {
      carregarLicenciamentos(veiculoEditando.id);
    }
  }, [veiculoEditando]);

  const carregarLicenciamentos = async (veiculoId) => {
    try {

      const response = await axios.get(`${API_BASE_URL}/licenciamentos/${veiculoId}`, getAuthHeader());
      setLicenciamentos(response.data);
    } catch (error) {
      console.error("Erro ao carregar licenciamentos:", error);
    }
  };


  const handleExcluirLicenciamento = (index) => {
    setFormVeiculo(prev => ({
      ...prev,
      licenciamentos: prev.licenciamentos.filter((_, i) => i !== index)
    }));
  };

  const handleEditarLicenciamento = (index) => {
    const novoAno = prompt("Editar ano:", formVeiculo.licenciamentos[index].ano);
    if (novoAno && novoAno !== formVeiculo.licenciamentos[index].ano) {
      setFormVeiculo(prev => ({
        ...prev,
        licenciamentos: prev.licenciamentos.map((item, i) =>
          i === index ? { ...item, ano: novoAno } : item
        )
      }));
    }
  };

  // Obter token do localStorage
  const getAuthHeader = () => {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };
  };

  // Busca automática de endereço pelo CEP (ViaCEP) — não bloqueia o formulário se falhar
  const buscarCepCliente = async (cepValor) => {
    const cep = cepValor.replace(/\D/g, '');
    if (cep.length !== 8) return;

    setBuscandoCep(true);
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
      if (response.data && !response.data.erro) {
        setFormCliente(prev => ({
          ...prev,
          logradouro: response.data.logradouro || prev.logradouro,
          bairro: response.data.bairro || prev.bairro,
          cidade: response.data.localidade || prev.cidade,
          uf: response.data.uf || prev.uf
        }));
      }
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
      // Não bloqueia o cadastro — o usuário pode preencher manualmente
    } finally {
      setBuscandoCep(false);
    }
  };

  const formatarCepInput = (valor) => {
    const num = valor.replace(/\D/g, '').slice(0, 8);
    if (num.length <= 5) return num;
    return `${num.slice(0, 5)}-${num.slice(5)}`;
  };

  const formatarEnderecoCompleto = (pessoa) => {
    if (!pessoa) return '';
    const partes = [];
    if (pessoa.logradouro) {
      let linha = pessoa.logradouro;
      if (pessoa.numero) linha += `, nº ${pessoa.numero}`;
      if (pessoa.complemento) linha += ` - ${pessoa.complemento}`;
      partes.push(linha);
    }
    if (pessoa.bairro) partes.push(pessoa.bairro);
    if (pessoa.cidade || pessoa.uf) {
      partes.push([pessoa.cidade, pessoa.uf].filter(Boolean).join('/'));
    }
    return partes.join(' - ');
  };

  // Validações
  const validateCliente = () => {
    const newErrors = {};
    if (!formCliente.nome) newErrors.nome = 'Nome é obrigatório';

    if (!formCliente.cpfCnpj) {
      newErrors.cpfCnpj = 'CPF/CNPJ é obrigatório';
      //} //else if (!cpf.isValid(formCliente.cpfCnpj) && !cnpj.isValid(formCliente.cpfCnpj)) {
      //newErrors.cpfCnpj = 'CPF/CNPJ inválido';
    }

    if (!validarCpfCnpj(formCliente.cpfCnpj)) {
      newErrors.cpfCnpj = 'CPF/CNPJ inválido!';
    }

    // verificaCpfCnpj é assíncrona: o resultado dela fica no ref, senão o cadastro seguia até o servidor e voltava com erro
    if (cpfDuplicadoRef.current) {
      newErrors.cpfCnpj = 'CPF/CNPJ já cadastrado!';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateVeiculo = () => {
    const newErrors = {};
    if (!formVeiculo.placa) newErrors.placa = 'Placa é obrigatória';
    if (formVeiculo.placa && formVeiculo.placa.length < 8) newErrors.placa = 'Placa incompleta';
    if (!formVeiculo.marcaModelo) newErrors.marcaModelo = 'Marca/Modelo é obrigatório';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Manipuladores de formulário
  const handleClienteChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormCliente(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleVeiculoChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormVeiculo(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const licenciamentosUnicos = formVeiculo.licenciamentos?.filter((value, index, self) =>
    index === self.findIndex(l => l.ano === value.ano)
  );

  // Pesquisar clientes
  const executarPesquisa = async () => {
    if (!termoPesquisa.trim()) return;
    if (termoPesquisa.trim().length < 3){
      addToast('warning', 'Por favor, informe ao menos 3 caracteres para a pesquisa');
      return;
    } 
    setLoading(true);
    setResultadosPesquisa([]);
    setTermoPesquisa(removerMascaraCPFCNPJ(termoPesquisa));

    try {
      // Tentar buscar por CPF/CNPJ primeiro
      try {
        const responseCpf = await axios.get(
          `${API_BASE_URL}/clientes/cpfcnpj/${termoPesquisa}`,
          getAuthHeader()
        );

        if (responseCpf.data) {
          setResultadosPesquisa([{ tipo: 'cliente', dados: responseCpf.data }]);
          return;
        }
      } catch (error) {
        console.log('Nenhum resultado por CPF/CNPJ, tentando por nome...');
      }

      // Se não encontrou por CPF/CNPJ, busca por nome
      const responseNome = await axios.get(
        `${API_BASE_URL}/clientes/nome/${termoPesquisa.toLowerCase()}`,
        getAuthHeader()
      );

      if (responseNome.data && responseNome.data.length > 0) {
        setResultadosPesquisa(responseNome.data.map(cliente => ({
          tipo: 'cliente',
          dados: cliente
        })));
      }
    } catch (error) {
      console.error('Erro na pesquisa:', error);
      addToast('error', 'Erro ao pesquisar clientes');
    } finally {
      setLoading(false);
    }
  };

  // Busca por placa (com ou sem hífen, em qualquer padrão) ou chassi (17 caracteres)
  const buscarPorPlacaOuChassi = async () => {
    const limpo = termoPlaca.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (limpo.length < 7) {
      addToast('warning', 'Digite a placa completa (7 caracteres) ou o chassi (17 caracteres).');
      return;
    }
    setLoading(true);
    try {
      const veiculo = limpo.length === 17
        ? await buscarVeiculoPorChassi(limpo)
        : (await buscarVeiculoPorPlaca(limpo)) || (await buscarVeiculoPorChassi(limpo));
      setVeiculoAchado(veiculo || null);
    } finally {
      setLoading(false);
    }
  };

  const fecharBuscaPlaca = () => {
    setModalPlacaAberto(false);
    setTermoPlaca('');
    setVeiculoAchado(undefined);
  };

  // Abre o dono do veículo achado, como a pesquisa de clientes, e destaca o veículo na lista
  const abrirVeiculoAchado = async () => {
    const veiculo = veiculoAchado;
    fecharBuscaPlaca();
    await selecionarCliente({ dados: { idCliente: veiculo.idCliente } });
    setVeiculoDestacado(veiculo.idVeiculo);
  };

  // Rola até o veículo destacado e tira o destaque depois de alguns segundos
  useEffect(() => {
    if (!veiculoDestacado || !clienteSelecionado) return undefined;
    const elemento = document.getElementById(`veiculo-${veiculoDestacado}`);
    if (elemento) elemento.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const timer = setTimeout(() => setVeiculoDestacado(null), 6000);
    return () => clearTimeout(timer);
  }, [veiculoDestacado, clienteSelecionado]);

  // Selecionar cliente da pesquisa
  const selecionarCliente = async (cliente) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/clientes/${cliente.dados.idCliente}`,
        getAuthHeader()
      );

      setClienteSelecionado(response.data);
      setFormCliente({
        idCliente: response.data.idCliente,
        nome: response.data.nome,
        cpfCnpj: removerMascaraCPFCNPJ(response.data.cpfCnpj),
        email: response.data.email,
        telefone: response.data.telefone,
        rg: response.data.rg || '',
        cep: response.data.cep || '',
        logradouro: response.data.logradouro || '',
        numero: response.data.numero || '',
        complemento: response.data.complemento || '',
        bairro: response.data.bairro || '',
        cidade: response.data.cidade || '',
        uf: response.data.uf || '',
        ativo: response.data.ativo
      });

      setModoEdicao(true);
      setModalPesquisaAberto(false);
      setTermoPesquisa('');
      setResultadosPesquisa([]);

      addToast('warning', 'Cliente selecionado para edição. Os campos foram preenchidos com os dados atuais. Faça as alterações necessárias e clique em "Atualizar Cliente".');
    } catch (error) {
      console.error('Erro ao carregar cliente:', error);
      addToast('error', 'Erro ao carregar dados do cliente');
    } finally {
      setLoading(false);
    }
  };

  // CRUD Clientes
  const adicionarCliente = async () => {
    if (!validateCliente()) return;
    setLoading(true);

    try {
      let response;
      if (formCliente.idCliente) {
        // Edição
        response = await axios.put(
          `${API_BASE_URL}/clientes/${formCliente.idCliente}`,
          formCliente,
          getAuthHeader()
        );
        setClienteSelecionado(response.data);
        addToast('success', 'Cliente atualizado com sucesso!');
        setModoEdicao(false);
      } else {
        // Novo
        response = await axios.post(
          `${API_BASE_URL}/clientes`,
          formCliente,
          getAuthHeader()
        );
        setClienteSelecionado(response.data);
        addToast('success', 'Cliente cadastrado com sucesso!');
        //handleCadastroSuccess(response.data); // Adiciona esta linha
        if (importacao) await anexarDocumentoImportado(response.data);
      }
      resetFormCliente();
    } catch (error) {
      console.error('Erro ao salvar cliente:', error);
      addToast('error', 'Erro ao salvar cliente');
    } finally {
      setLoading(false);
    }
  };

  const editarCliente = (cliente) => {
    setFormCliente({
      idCliente: cliente.idCliente,
      nome: cliente.nome,
      cpfCnpj: cliente.cpfCnpj,
      email: cliente.email,
      telefone: cliente.telefone,
      rg: cliente.rg || '',
      cep: cliente.cep || '',
      logradouro: cliente.logradouro || '',
      numero: cliente.numero || '',
      complemento: cliente.complemento || '',
      bairro: cliente.bairro || '',
      cidade: cliente.cidade || '',
      uf: cliente.uf || '',
      ativo: cliente.ativo
    });
    setModoEdicao(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const resetFormCliente = () => {
    setFormCliente({
      idCliente: null,
      nome: '',
      cpfCnpj: '',
      email: '',
      telefone: '',
      rg: '',
      cep: '',
      logradouro: '',
      numero: '',
      complemento: '',
      bairro: '',
      cidade: '',
      uf: '',
      ativo: true
    });
    setImportacao(null);
    setModoEdicao(false);
  };

  // Guarda o documento lido na importação como documento do cliente recém-cadastrado
  const anexarDocumentoImportado = async (cliente) => {
    const { arquivo, divergente } = resolverAnexo(importacao, cliente.cpfCnpj);
    if (divergente) {
      addToast('warning', 'O documento importado é de outro CPF/CNPJ; não foi anexado a este cliente. Anexe-o pelos documentos do cliente, se for o caso.');
      return;
    }
    if (!arquivo) return;
    const anexou = await anexarDocumentoCliente(API_BASE_URL, cliente.idCliente, arquivo, getAuthHeader());
    if (!anexou) {
      addToast('warning', 'Cliente salvo, mas não foi possível anexar o documento. Anexe-o pelos documentos do cliente.');
    }
  };

  // Recebe nome, CPF e RG lidos do documento (CNH, RG, CIN) e preenche o formulário.
  const aplicarDadosDocumento = (dados) => {
    setFormCliente(prev => ({ ...prev, ...dados }));
    if (dados.cpfCnpj) verificaCpfCnpj(dados.cpfCnpj); // valida o CPF e checa se já está cadastrado
  };

  const removerCliente = async (id) => {
    showConfirm(
      'Tem certeza que deseja remover este cliente e todos seus veículos?',
      async () => {
        setLoading(true);

        try {
          await axios.delete(`${API_BASE_URL}/clientes/${id}`, getAuthHeader());
          setClienteSelecionado(null);
          resetFormCliente();
          addToast('success', 'Cliente removido com sucesso!');
        } catch (error) {
          console.error('Erro ao remover cliente:', error);
          addToast('error', error.response?.data?.message || 'Erro ao remover cliente');
        } finally {
          setLoading(false);
        }
      },
      'Excluir Cliente'
    );

  };

  const abrirModalVeiculo = (veiculo = null) => {
    setVeiculoEditando(veiculo);

    setFormVeiculo({
      idVeiculo: veiculo?.idVeiculo || null,
      placa: veiculo?.placa || '',
      marcaModelo: veiculo?.marcaModelo || '',
      cor: veiculo?.cor || '',
      ano: veiculo?.ano || '',
      observacao: veiculo?.observacao || '',
      renavam: veiculo?.renavam || '',
      chassi: veiculo?.chassi || '',
      motor: veiculo?.motor || '',

      licenciamentos: Array.isArray(veiculo?.licenciamentos)
        ? [...veiculo.licenciamentos]
        : []
    });

    setImportacaoVeiculo(null);
    setDadosImportadosVeiculo(null);
    setVeiculoJaDoCliente(null);
    setModalVeiculoAberto(true);
  };

  // Recebe placa, RENAVAM, chassi, nº do motor, marca/modelo, cor e ano lidos do CRLV/ATPV e preenche o formulário do veículo.
  // A placa passa pelo mesmo tratamento da digitação (máscara e checagem de placa já cadastrada); ao editar um
  // veículo existente a placa não é trocada.
  const aplicarDadosVeiculo = (dados) => {
    const { placa, ...demais } = dados;
    setDadosImportadosVeiculo(dados);
    setFormVeiculo(prev => ({ ...prev, ...demais }));
    if (placa && !veiculoEditando) handlePlacaChange({ target: { value: placa } });
  };


  const salvarVeiculo = async () => {
    if (!validateVeiculo()) return;
    if (!clienteSelecionado) return;

    setLoading(true);

    try {
      const veiculoData = {
        ...formVeiculo,
        cliente: { idCliente: clienteSelecionado.idCliente },
        licenciamentos: Array.isArray(formVeiculo.licenciamentos)
          ? formVeiculo.licenciamentos
          : []
      };

      let response;
      if (veiculoEditando) {
        // Modo edição - ATUALIZA o veículo existente
        response = await axios.put(
          `${API_BASE_URL}/veiculos/${formVeiculo.idVeiculo}`,
          veiculoData,
          getAuthHeader()
        );

        // Atualiza a lista substituindo o veículo antigo pelo novo
        const veiculosAtualizados = clienteSelecionado.veiculos.map(v =>
          v.idVeiculo === formVeiculo.idVeiculo ? response.data : v
        );

        setClienteSelecionado({
          ...clienteSelecionado,
          veiculos: veiculosAtualizados
        });
      } else {
        // Modo criação - ADICIONA um novo veículo
        response = await axios.post(
          `${API_BASE_URL}/veiculos`,
          veiculoData,
          getAuthHeader()
        );

        setClienteSelecionado({
          ...clienteSelecionado,
          veiculos: [...clienteSelecionado.veiculos, response.data]
        });
      }

      const { arquivo: arquivoVeiculo, divergente } = resolverAnexo(importacaoVeiculo, response.data.placa);
      if (divergente) {
        addToast('warning', 'O documento importado é de outra placa; não foi anexado a este veículo. Anexe-o pelos documentos do veículo, se for o caso.');
      }
      if (arquivoVeiculo) {
        const anexou = await anexarDocumentoVeiculo(API_BASE_URL, response.data.idVeiculo, arquivoVeiculo, getAuthHeader());
        if (!anexou) addToast('warning', 'Veículo salvo, mas não foi possível anexar o documento. Anexe-o pelos documentos do veículo.');
      }
      setImportacaoVeiculo(null);

      const redirectOrigin = localStorage.getItem('redirectAfterClientCreation');

      if (redirectOrigin) {
        localStorage.removeItem('redirectAfterClientCreation');
        localStorage.removeItem('clienteSearchTerm');
        localStorage.removeItem('veiculoPlaca');

        navigate(redirectOrigin, {
          state: {
            clienteSelecionado: {
              ...clienteSelecionado,
              veiculos: veiculoEditando
                ? clienteSelecionado.veiculos.map(v =>
                  v.idVeiculo === formVeiculo.idVeiculo ? response.data : v
                )
                : [...clienteSelecionado.veiculos, response.data]
            },
            veiculoSelecionado: response.data
          }
        });
      } else {
        setModalVeiculoAberto(false);
        addToast('success', `Veículo ${veiculoEditando ? 'atualizado' : 'cadastrado'} com sucesso!`);
      }
    } catch (error) {
      console.error('Erro ao salvar veículo:', error);
      addToast('error', 'Erro ao salvar veículo: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const removerVeiculo = async (veiculoId) => {

    showConfirm(
      'Tem certeza que deseja remover este veículo?',
      async () => {
        if (!clienteSelecionado) return;

        setLoading(true);
    
        try {
          await axios.delete(
            `${API_BASE_URL}/veiculos/${veiculoId}`,
            getAuthHeader()
          );
    
          const veiculosAtualizados = clienteSelecionado.veiculos.filter(v => v.idVeiculo !== veiculoId);
    
          setClienteSelecionado({
            ...clienteSelecionado,
            veiculos: veiculosAtualizados
          });
    
          addToast('success', 'Veículo removido com sucesso!');
        } catch (error) {
          console.error('Erro ao remover veículo:', error);
          addToast('error', error.response?.data?.message || 'Erro ao remover veículo');
        } finally {
          setLoading(false);
        }
      },
      'Excluir Veículo'
    );
  };
  const onlyNumbers = formCliente.cpfCnpj.replace(/\D/g, '');

  const normalizePlaca = (value) => {
    // Remove tudo que não for letra ou número
    const raw = value.toUpperCase().replace(/[^A-Z0-9]/g, '');

    // Se tiver menos de 3 caracteres, retorna o que já tem
    if (raw.length <= 3) {
      return raw;
    }

    // Insere hífen fixo na 4ª posição
    const parte1 = raw.slice(0, 3);         // LLL
    const parte2 = raw.slice(3, 7);         // NNNN ou NLLN

    return `${parte1}-${parte2}`.slice(0, 8); // Garante máximo de 8 caracteres
  };

  const handlePlacaChange = async (e) => {
    const value = e.target.value;
    const placaNormalizada = normalizePlaca(value);

    setFormVeiculo(prev => ({
      ...prev,
      placa: placaNormalizada
    }));

    // Verifica se a placa está completa (AAA-0000)
    if (placaNormalizada.length === 8) {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/veiculos/placa/${placaNormalizada}`,
          getAuthHeader()
        );

        // Se encontrou um veículo com esta placa e não é o mesmo que está sendo editado
        if (response.data && response.data.idVeiculo !== formVeiculo.idVeiculo) {
          const doMesmoCliente = (clienteSelecionado?.veiculos || []).find(v => v.idVeiculo === response.data.idVeiculo);
          if (doMesmoCliente) {
            // já é deste cliente: em vez de "outro cliente" (e de oferecer transferir), oferece abrir o cadastro dele
            setErrors(prev => ({ ...prev, placa: PLACA_JA_DO_CLIENTE }));
            setVeiculoJaDoCliente(doMesmoCliente);
            setPlacaATransferir(null);
          } else {
            setErrors(prev => ({
              ...prev,
              placa: 'Esta placa já está cadastrada para outro cliente'
            }));
            setVeiculoJaDoCliente(null);
            setPlacaATransferir(response.data)
          }
        } else {
          setErrors(prev => ({ ...prev, placa: undefined }));
          setVeiculoJaDoCliente(null);
        }
      } catch (error) {
        if (error.response?.status === 404) {
          // Placa não existe - válida
          setErrors(prev => ({ ...prev, placa: undefined }));
          setVeiculoJaDoCliente(null);
        } else {
          console.error('Erro ao verificar placa:', error);
        }
      }
    }
  };

  const formatarCpfCnpj = (valor) => {
    const num = valor.replace(/\D/g, '');

    if (num.length <= 11) {
      // CPF
      return num
        .padStart(11, '0')
        .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else {
      // CNPJ
      return num
        .padStart(14, '0')
        .replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
    }
  };

  function removerMascaraCPFCNPJ(documento) {
    // Verifica se é string e remove todos os caracteres não numéricos
    if (typeof documento === 'string') {
      return documento.replace(/\D/g, '');
    }

    // Caso já seja número (como number ou bigint)
    if (typeof documento === 'number' || typeof documento === 'bigint') {
      return documento.toString();
    }

    // Retorna vazio para outros tipos (null, undefined, object, etc)
    return '';
  }

  useEffect(() => {
    const searchTerm = localStorage.getItem('clienteSearchTerm');
    if (searchTerm && !formCliente.nome && !formCliente.cpfCnpj) {
      // Verifica se parece ser um CPF/CNPJ (apenas números)
      if (/^\d+$/.test(searchTerm)) {
        setFormCliente(prev => ({
          ...prev,
          cpfCnpj: searchTerm
        }));
      } else {
        // Assume que é um nome
        setFormCliente(prev => ({
          ...prev,
          nome: searchTerm
        }));
      }
    }
  }, []);

  // A placa do documento já é de um veículo deste cliente: abre o cadastro dele para edição, e mantém o arquivo
  // importado para anexar ao salvar. Os dados do documento só entram nos campos que estão VAZIOS no cadastro:
  // nada do que já está preenchido é sobrescrito. Os que diferem são apenas apontados, para o usuário decidir.
  const editarVeiculoJaCadastrado = async () => {
    const importacaoAtual = importacaoVeiculo;
    const lidos = dadosImportadosVeiculo || {};
    const rotulos = { marcaModelo: 'marca/modelo', cor: 'cor', ano: 'ano', renavam: 'RENAVAM', chassi: 'chassi', motor: 'nº do motor' };

    // Parte do cadastro ATUAL do servidor (com os licenciamentos completos), não da cópia que a tela já tinha: assim o
    // "Atualizar Veículo" nunca grava por cima de algo que mudou depois. Se não conseguir carregar, não abre.
    let existente;
    try {
      const { data } = await axios.get(`${API_BASE_URL}/veiculos/${veiculoJaDoCliente.idVeiculo}`, getAuthHeader());
      existente = data;
    } catch (error) {
      console.error('Erro ao carregar o veículo cadastrado:', error);
    }
    if (!existente || !existente.idVeiculo) {
      addToast('error', 'Não foi possível carregar o cadastro do veículo. Tente novamente.');
      return;
    }

    const diferentes = Object.keys(rotulos).filter((campo) => lidos[campo] && existente[campo] && String(existente[campo]).trim().toUpperCase() !== String(lidos[campo]).trim().toUpperCase());

    abrirModalVeiculo(existente);
    setFormVeiculo(prev => {
      const novo = { ...prev };
      Object.keys(rotulos).forEach((campo) => { if (lidos[campo] && !prev[campo]) novo[campo] = lidos[campo]; });
      return novo;
    });
    setImportacaoVeiculo(importacaoAtual);
    setDadosImportadosVeiculo(lidos);
    addToast(
      diferentes.length ? 'warning' : 'success',
      diferentes.length
        ? `Veículo já cadastrado: aberto para edição. Os dados já preenchidos foram mantidos. Diferem do documento: ${diferentes.map(c => rotulos[c]).join(', ')}.`
        : 'Veículo já cadastrado: aberto para edição. Ao atualizar, o documento importado será anexado a ele.'
    );
  };

  const handleReassignVehicle = async () => {
    const nomeCliente = placaATransferir.nomeCliente.toUpperCase();
    const nomeVeiculo = placaATransferir.marcaModelo.toUpperCase();
    const nomeClienteAtual = clienteSelecionado.nome.toUpperCase();

    showConfirm(
      `Transferir o veículo ${nomeVeiculo} cadastrado para ${nomeCliente} para o cliente atual(${nomeClienteAtual})?`,
      async () => {
        try {
          setLoading(true);
    
          // 1. Busca os dados atuais do veículo
          const { data: veiculo } = await axios.get(
            `${API_BASE_URL}/veiculos/${placaATransferir.idVeiculo}`,
            getAuthHeader()
          );
    
          // 2. Atualiza o cliente do veículo
          const updatedVeiculo = {
            ...veiculo,
            cliente: { idCliente: clienteSelecionado.idCliente }
          };
    
          // 3. Envia a atualização
          await axios.put(
            `${API_BASE_URL}/veiculos/${placaATransferir.idVeiculo}`,
            updatedVeiculo,
            getAuthHeader()
          );
    
          // 4. Atualiza a lista de veículos do cliente
          const updatedVeiculos = [...clienteSelecionado.veiculos, updatedVeiculo];
          setClienteSelecionado({
            ...clienteSelecionado,
            veiculos: updatedVeiculos
          });
    
          // 4b. Documento importado (CRLV/ATPV): anexa ao veículo transferido, se a placa for a do documento
          const { arquivo: arquivoTransf, divergente } = resolverAnexo(importacaoVeiculo, placaATransferir.placa);
          setImportacaoVeiculo(null);
          if (divergente) {
            addToast('warning', 'O documento importado é de outra placa; não foi anexado ao veículo transferido.');
          } else if (arquivoTransf) {
            const anexou = await anexarDocumentoVeiculo(API_BASE_URL, placaATransferir.idVeiculo, arquivoTransf, getAuthHeader());
            if (!anexou) addToast('warning', 'Veículo transferido, mas não foi possível anexar o documento. Anexe-o pelos documentos do veículo.');
          }

          // 5. Limpa o formulário e mensagens de erro
          setFormVeiculo({
            idVeiculo: null,
            placa: '',
            marcaModelo: '',
            cor: '',
            ano: '',
            observacao: '',
            renavam: '',
            chassi: '',
            motor: '',

            licenciamentos: []
          });
          setErrors({});

          addToast('success', 'Veículo transferido com sucesso!');
        } catch (error) {
          console.error('Erro ao transferir veículo:', error);
          addToast('error', 'Erro ao transferir veículo: ' + (error.response?.data?.message || error.message));
        } finally {
          setLoading(false);
        }
      },
      'Transferir Veículo',
      'Transferir'
    );
  };
  // A lupa só habilita para CNPJ completo e válido, ainda não cadastrado
  const podeConsultarCnpj = formCliente.cpfCnpj.length === 14
    && validarCpfCnpj(formCliente.cpfCnpj)
    && !errors.cpfCnpj
    && !loading
    && !buscandoCnpj;

  const verificaCpfCnpj = async(e) =>{
    const value = e;
    setFormCliente(prev => ({ ...prev, cpfCnpj: value }))
    cpfDuplicadoRef.current = false;

    if (value.length === 11 || value.length === 14) {
      try {

        if (!validarCpfCnpj(value)) {
          setErrors(prev => ({
            ...prev,
            cpfCnpj: 'CPF/CNPJ inválido!'
          }));
          return true;
        }

        const response = await axios.get(
          `${API_BASE_URL}/clientes/cpfcnpj/${value}`,
          getAuthHeader()
        );
  
        // Se encontrou um veículo com esta placa e não é o mesmo que está sendo editado
        if (response.data && response.data.idCliente !== formCliente.idCliente) {
          setErrors(prev => ({
            ...prev,
            cpfCnpj: 'Cliente já cadastrado!'
          }));
          cpfDuplicadoRef.current = true;
          return true;
        } else {
          setErrors(prev => ({ ...prev, cpfCnpj: undefined }));
        }
      } catch (error) {
          console.error('Erro ao verificar CPF/CNPJ:', error);
      }
      return false;
    }
  }

  // Preenche os dados do cliente a partir do CNPJ digitado, ao clicar na lupa.
  // Substitui os campos de identificação, contato e endereço pelos do CNPJ consultado (inclusive
  // limpando o que a consulta não trouxe), para não sobrar dado de um CNPJ consultado antes.
  const preencherPorCnpj = async () => {
    if (buscandoCnpj) return;
    setBuscandoCnpj(true);
    const { dados, erro } = await consultarCnpj(formCliente.cpfCnpj, API_BASE_URL, getAuthHeader());
    setBuscandoCnpj(false);

    if (!dados) {
      addToast('error', erro);
      return;
    }

    setFormCliente(prev => {
      const novo = { ...prev };
      Object.keys(dados).forEach(campo => {
        novo[campo] = dados[campo] || '';
      });
      return novo;
    });
    const camposOpcionais = {
      email: 'e-mail', telefone: 'telefone', cep: 'CEP', logradouro: 'endereço', bairro: 'bairro', cidade: 'cidade',
    };
    const faltando = Object.keys(camposOpcionais).filter(campo => !dados[campo]).map(campo => camposOpcionais[campo]);
    if (faltando.length > 0) {
      addToast('warning', `Dados preenchidos pelo CNPJ. Não encontrei: ${faltando.join(', ')}. Preencha manualmente.`);
    } else {
      addToast('success', 'Dados preenchidos a partir do CNPJ.');
    }
  };

  // Validação de CPF/CNPJ: regra única em others/documentoFiscal.js, espelho do backend

  return (
    <div style={styles.container}>
      <Header />
      <div style={styles.content}>
        {/* Cabeçalho */}
        <div style={styles.header}>
          <div style={styles.titleContainer}>
            <FaUser style={styles.titleIcon} />
            <h1 style={styles.title}>Gerenciamento de Clientes e Veículos</h1>
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button
              onClick={() => setModalPesquisaAberto(true)}
              style={styles.searchButton}
              disabled={loading}
            >
              <FaSearch /> {clienteSelecionado ? 'Trocar Cliente' : 'Pesquisar Cliente'}
            </button>
            <button
              onClick={() => setModalPlacaAberto(true)}
              style={{ ...styles.searchButton, backgroundColor: '#008080' }}
              disabled={loading}
              title="Localiza o veículo pela placa ou pelo chassi e abre o cliente dono dele"
            >
              <FaCar /> Pesquisar por Placa/Chassi
            </button>
          </div>
        </div>

        {/* Formulário de Cliente */}
        <div style={styles.formContainer}>
          <div style={styles.formHeader}>
            <h2 style={styles.formTitle}>
              {modoEdicao ? 'Editar Cliente' : 'Cadastrar Novo Cliente'}
            </h2>
            {modoEdicao && (
              <div style={styles.edicaoBadge}>
                MODO EDIÇÃO - Você está editando um cliente existente
              </div>
            )}
          </div>

          {modoEdicao && (
            <button
              onClick={resetFormCliente}
              style={styles.secondaryButton}
              disabled={loading}
            >
              <FaArrowLeft /> Cancelar Edição
            </button>
          )}

          {/* Importação de documento (CNH, RG, CIN): lê nome, CPF e RG e guarda o arquivo no cliente */}
          {!modoEdicao && (
            <div style={styles.importarDocumento}>
              <ImportarDocumento
                onDadosLidos={aplicarDadosDocumento}
                importacao={importacao}
                onImportacaoChange={setImportacao}
                disabled={loading}
              />
              <span style={styles.hintText}>
                <FaFileAlt /> Ficha em branco para preencher a caneta:{' '}
                <button type="button" onClick={() => abrirFichaCliente('completa')} style={styles.linkButton}>Completa</button>
                {' | '}
                <button type="button" onClick={() => abrirFichaCliente('contatoEndereco')} style={styles.linkButton}>Só endereço e contato</button>
              </span>
            </div>
          )}

          {/* Primeira linha com 2 campos */}
          <div style={styles.formRow}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Nome*</label>
              <input
                name="nome"
                value={formCliente.nome}
                onChange={handleClienteChange}
                placeholder="Nome completo"
                disabled={loading}
                style={{ ...styles.input, ...(errors.nome && styles.inputError) }}
              />
              {errors.nome && <span style={styles.errorText}>{errors.nome}</span>}
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>CPF/CNPJ*</label>
              <div style={styles.cnpjRow}>
                <CpfCnpjInput
                  value={formCliente.cpfCnpj}
                  onChange={(e) =>
                    verificaCpfCnpj(e.target.value)
                  }
                  disabled={loading || modoEdicao}
                  style={{ ...styles.input, flex: 1, minWidth: 0 }}
                  errorStyle={errors.cpfCnpj && styles.inputError}
                />
                {!modoEdicao && (
                  <button
                    type="button"
                    onClick={preencherPorCnpj}
                    disabled={!podeConsultarCnpj}
                    title={podeConsultarCnpj
                      ? 'Buscar dados do CNPJ (Receita Federal)'
                      : 'Digite um CNPJ válido para buscar os dados'}
                    style={{ ...styles.cnpjButton, ...(!podeConsultarCnpj && styles.cnpjButtonDisabled) }}
                  >
                    <FaSearch />
                  </button>
                )}
              </div>
              {errors.cpfCnpj && <span style={styles.errorText}>{errors.cpfCnpj}</span>}
              {buscandoCnpj && <span style={styles.hintText}>Consultando CNPJ...</span>}
              {modoEdicao && <span style={styles.hintText}>CPF/CNPJ não pode ser alterado</span>}
            </div>
          </div>

          {/* Segunda linha com 2 campos */}
          <div style={styles.formRow}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Telefone</label>
              <InputMask
                mask="(99) 99999-9999"
                name="telefone"
                value={formCliente.telefone}
                onChange={handleClienteChange}
                placeholder="(00) 00000-0000"
                disabled={loading}
                style={styles.input}
              />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Email</label>
              <input
                name="email"
                value={formCliente.email}
                onChange={handleClienteChange}
                placeholder="email@exemplo.com"
                disabled={loading}
                style={styles.input}
              />
            </div>
          </div>

          {/* RG — usado no preenchimento de Procurações */}
          <div style={styles.formRow}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>RG</label>
              <input
                name="rg"
                value={formCliente.rg}
                onChange={handleClienteChange}
                placeholder="0000000000"
                disabled={loading}
                style={styles.input}
              />
            </div>
          </div>

          {/* Endereço — detalhado, com busca automática por CEP. Nenhum campo aqui é obrigatório. */}
          <div style={styles.sectionTitle}>Endereço</div>
          <div style={styles.formRow}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>CEP</label>
              <input
                name="cep"
                value={formCliente.cep}
                onChange={(e) => {
                  const formatado = formatarCepInput(e.target.value);
                  setFormCliente(prev => ({ ...prev, cep: formatado }));
                  if (formatado.replace(/\D/g, '').length === 8) buscarCepCliente(formatado);
                }}
                placeholder="00000-000"
                disabled={loading}
                style={styles.input}
              />
              {buscandoCep && <span style={styles.hintText}>Buscando endereço...</span>}
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Cidade</label>
              <input
                name="cidade"
                value={formCliente.cidade}
                onChange={handleClienteChange}
                placeholder="Ex.: Canguçu"
                disabled={loading}
                style={styles.input}
              />
            </div>
            <div style={{ ...styles.inputGroup, flex: '0 0 80px' }}>
              <label style={styles.label}>UF</label>
              <input
                name="uf"
                value={formCliente.uf}
                onChange={handleClienteChange}
                placeholder="Ex.: RS"
                maxLength={2}
                disabled={loading}
                style={{ ...styles.input, textTransform: 'uppercase' }}
              />
            </div>
          </div>
          <div style={styles.formRow}>
            <div style={{ ...styles.inputGroup, flex: '2' }}>
              <label style={styles.label}>Logradouro</label>
              <input
                name="logradouro"
                value={formCliente.logradouro}
                onChange={handleClienteChange}
                placeholder="Ex.: Rua Joaquim Paulo de Freitas"
                disabled={loading}
                style={styles.input}
              />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Número</label>
              <input
                name="numero"
                value={formCliente.numero}
                onChange={handleClienteChange}
                placeholder="Ex.: 140"
                disabled={loading}
                style={styles.input}
              />
            </div>
          </div>
          <div style={styles.formRow}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Complemento</label>
              <input
                name="complemento"
                value={formCliente.complemento}
                onChange={handleClienteChange}
                placeholder="Ex.: Casa, apto, bloco"
                disabled={loading}
                style={styles.input}
              />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Bairro</label>
              <input
                name="bairro"
                value={formCliente.bairro}
                onChange={handleClienteChange}
                placeholder="Ex.: Triângulo"
                disabled={loading}
                style={styles.input}
              />
            </div>
          </div>

          <button
            onClick={adicionarCliente}
            style={styles.primaryButton}
            disabled={loading}
          >
            {loading ? 'Processando...' : (
              <>
                {modoEdicao ? <FaEdit /> : <FaPlus />}
                {modoEdicao ? 'Atualizar Cliente' : 'Adicionar Cliente'}
              </>
            )}
          </button>
          {showBackButton && clienteSelecionado && (
            <button
              onClick={handleBackToOS}
              style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                padding: '12px 24px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
              }}
            >
              <FaArrowLeft /> Voltar para Ordem de Serviço
            </button>
          )}
        </div>

        {/* Área do Cliente Selecionado */}
        {clienteSelecionado ? (
          <div style={styles.clienteCard}>
            <div style={styles.clienteHeader}>
              <div style={styles.clienteInfo}>
                <h3 style={styles.clienteNome}>{clienteSelecionado.nome}</h3>
                <span style={styles.clienteDocumento}>
                  {formatarCpfCnpj(clienteSelecionado.cpfCnpj)}
                  {clienteSelecionado.rg && ` · RG ${clienteSelecionado.rg}`}
                </span>
                {formatarEnderecoCompleto(clienteSelecionado) && (
                  <span style={{ ...styles.clienteDocumento, marginBottom: '4px' }}>
                    {formatarEnderecoCompleto(clienteSelecionado)}
                  </span>
                )}
              </div>
              <div style={styles.clienteActions}>
                {/* Botão de Documentos do Cliente  */}
                <ClienteDocumentButton
                  cliente={clienteSelecionado}
                  onClick={() => {
                    setShowClienteFileModal(true);
                    fetchClienteFiles(clienteSelecionado.idCliente);
                  }}
                  fileCount={clienteFiles.length}
                />
                {/* ── NOVO: histórico de processos do cliente */}
                <BotaoProcessos tipo="cliente" id={clienteSelecionado.idCliente} titulo={clienteSelecionado.nome} />
                <button
                  onClick={() => editarCliente(clienteSelecionado)}
                  style={styles.editButton}
                  disabled={loading}
                >
                  <FaEdit /> Editar
                </button>
                <button
                  onClick={() => removerCliente(clienteSelecionado.idCliente)}
                  style={styles.deleteButton}
                  disabled={loading}
                >
                  <FaTrash /> Remover
                </button>
              </div>
            </div>

            {/* Veículos do Cliente */}
            {/* Veículos do Cliente */}
            <div style={styles.veiculosHeader}>
              <h3 style={styles.veiculosTitle}>Veículos</h3>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button
                  onClick={() => abrirModalVeiculo()}
                  style={styles.primaryButton}
                  disabled={loading}
                >
                  <FaPlus /> Adicionar Veículo
                </button>


              </div>
            </div>
            {/* Modal de Documentos do Cliente */}
            {showClienteFileModal && clienteSelecionado && (
              <div style={styles.modalOverlay}>
                <div style={styles.fileModal}>
                  <div style={styles.fileModalHeader}>
                    <h3 style={styles.fileModalTitle}>
                      Documentos do Cliente {clienteSelecionado.nome} - {formatarCpfCnpj(clienteSelecionado.cpfCnpj)}
                    </h3>
                    <button
                      onClick={() => {
                        setShowClienteFileModal(false);
                        setSelectedClienteFile(null);
                        setUploadClienteProgress(0);
                      }}
                      style={styles.fileModalCloseButton}
                    >
                      <FaTimes />
                    </button>
                  </div>
                    
                  <div style={styles.fileModalBody}>
                    {/* Seção de Upload */}
                    <div style={styles.uploadSection}>
                      <h4 style={styles.sectionTitle}>Enviar Novo Documento</h4>
                      <input
                        type="file"
                        onChange={handleClienteFileUpload}
                        style={styles.fileInput}
                        id="cliente-file-upload"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      />
                      <label htmlFor="cliente-file-upload" style={styles.uploadButton}>
                        <FaUpload /> Selecionar Arquivo
                      </label>
                      {selectedClienteFile && (
                        <div style={styles.fileInfo}>
                          <span style={styles.fileNameText}>{selectedClienteFile.name}</span>
                          <button
                            onClick={handleClienteUpload}
                            style={styles.confirmButton}
                            disabled={isUploadingCliente}
                          >
                            {isUploadingCliente ? 'Enviando...' : 'Confirmar Envio'}
                          </button>
                        </div>
                      )}
                      {uploadClienteProgress > 0 && uploadClienteProgress < 100 && (
                        <div style={styles.progressBar}>
                          <div style={{
                            width: `${uploadClienteProgress}%`,
                            backgroundColor: '#9b59b6',
                            height: '100%',
                            borderRadius: '4px'
                          }}></div>
                          <span style={styles.progressText}>{uploadClienteProgress}%</span>
                        </div>
                      )}
                      {uploadClienteError && (
                        <div style={styles.errorMessage}>{uploadClienteError}</div>
                      )}
                    </div>
                    
                    {/* Lista de Arquivos Existentes */}
                    <div style={styles.fileListSection}>
                      <h4 style={styles.sectionTitle}>Documentos Enviados</h4>
                      {clienteFiles.length === 0 ? (
                        <p style={styles.noFiles}>Nenhum documento encontrado</p>
                      ) : (
                        <ul style={styles.fileList}>
                          {clienteFiles.map((file) => (
                            <li key={file.id} style={styles.fileItem}>
                              <div style={styles.fileName}>
                                <FaFile style={{ marginRight: '8px', color: '#555' }} />
                                <div>
                                  <div style={styles.fileNameText}>{file.nomeOriginal}</div>
                                  <div style={styles.fileDate}>
                                    Enviado em: {new Date(file.dataEnvio).toLocaleDateString('pt-BR')}
                                  </div>
                                </div>
                              </div>
                              <div style={styles.fileActions}>
                                <button
                                  onClick={() => handleClienteDownload(file.id, file.nomeOriginal)}
                                  style={styles.downloadButton}
                                  title="Download"
                                >
                                  <FaDownload />
                                </button>
                                <button
                                  onClick={() => handleClienteDelete(file.id)}
                                  style={styles.deleteButton}
                                  title="Excluir"
                                >
                                  <FaTrash />
                                </button>
                              </div>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Modal de Gerenciamento de Arquivos */}
            {showFileModal && clienteSelecionado && (
              <div style={styles.modalOverlay}>
                <div style={styles.fileModal}>
                  <div style={styles.fileModalHeader}>
                    <h3 style={styles.fileModalTitle}>Documentos do Veículo {veiculoArquivos.placa} - {veiculoArquivos.marcaModelo}</h3>
                    <button
                      onClick={() => {
                        setShowFileModal(false);
                        setSelectedFile(null);
                        setUploadProgress(0);
                        setVeiculoArquivos(null);
                      }}
                      style={styles.fileModalCloseButton}
                    >
                      <FaTimes />
                    </button>
                  </div>

                  <div style={styles.fileModalBody}>
                    {/* Seção de Upload */}
                    <div style={styles.uploadSection}>
                      <h4 style={styles.sectionTitle}>Enviar Novo Documento</h4>
                      <input
                        type="file"
                        onChange={handleFileUpload}
                        style={styles.fileInput}
                        id="file-upload"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      />
                      <label htmlFor="file-upload" style={styles.uploadButton}>
                        <FaUpload /> Selecionar Arquivo
                      </label>
                      {selectedFile && (
                        <div style={styles.fileInfo}>
                          <span style={styles.fileNameText}>{selectedFile.name}</span>
                          <button
                            onClick={handleUpload}
                            style={styles.confirmButton}
                            disabled={isUploading}
                          >
                            {isUploading ? 'Enviando...' : 'Confirmar Envio'}
                          </button>
                        </div>
                      )}
                      {uploadProgress > 0 && uploadProgress < 100 && (
                        <div style={styles.progressBar}>
                          <div style={{
                            width: `${uploadProgress}%`,
                            backgroundColor: '#4CAF50',
                            height: '100%',
                            borderRadius: '4px'
                          }}></div>
                          <span style={styles.progressText}>{uploadProgress}%</span>
                        </div>
                      )}
                      {uploadError && (
                        <div style={styles.errorMessage}>{uploadError}</div>
                      )}
                    </div>

                    {/* Lista de Arquivos Existentes */}
                    <div style={styles.fileListSection}>
                      <h4 style={styles.sectionTitle}>Documentos Enviados</h4>
                      {files.length === 0 ? (
                        <p style={styles.noFiles}>Nenhum documento encontrado</p>
                      ) : (
                        <ul style={styles.fileList}>
                          {files.map((file) => (
                            <li key={file.id} style={styles.fileItem}>
                              <div style={styles.fileName}>
                                <FaFile style={{ marginRight: '8px', color: '#555' }} />
                                <div>
                                  <div style={styles.fileNameText}>{file.nomeOriginal}</div>
                                  <div style={styles.fileDate}>
                                    Enviado em: {new Date(file.dataEnvio).toLocaleDateString('pt-BR')}
                                  </div>
                                </div>
                              </div>
                              <div style={styles.fileActions}>
                                <button
                                  onClick={() => handleDownload(file.id, file.nomeOriginal)}
                                  style={styles.downloadButton}
                                  title="Download"
                                >
                                  <FaDownload />
                                </button>
                                <button
                                  onClick={() => handleDelete(file.id)}
                                  style={styles.deleteButton}
                                  title="Excluir"
                                >
                                  <FaTrash />
                                </button>
                              </div>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {clienteSelecionado.veiculos && clienteSelecionado.veiculos.length > 0 ? (
              <div style={styles.veiculosContainer}>
                {clienteSelecionado.veiculos.map(veiculo => (
                  <div key={veiculo.idVeiculo} id={`veiculo-${veiculo.idVeiculo}`}
                    style={veiculoDestacado === veiculo.idVeiculo ? { ...styles.veiculoCard, ...styles.veiculoDestacado } : styles.veiculoCard}>
                    <div style={styles.veiculoHeader}>
                      <FaCar style={styles.veiculoIcon} />
                      <div style={styles.veiculoInfo}>
                        <h4 style={styles.veiculoModelo}>{veiculo.marcaModelo}</h4>
                        <span style={styles.veiculoPlaca}>{veiculo.placa}</span>
                      </div>
                    </div>
                    <div style={styles.veiculoDetails}>
                      <div style={styles.detailRow}>
                        <span style={styles.detailLabel}>Cor:</span>
                        <span style={styles.detailValue}>{veiculo.cor}</span>
                      </div>
                      <div style={styles.detailRow}>
                        <span style={styles.detailLabel}>Ano:</span>
                        <span style={styles.detailValue}>{veiculo.ano}</span>
                      </div>
                      <div style={styles.detailRow}>
                        <span style={styles.detailLabel}>RENAVAM:</span>
                        <span style={styles.detailValue}>{veiculo.renavam}</span>
                      </div>
                      {veiculo.chassi && (
                        <div style={styles.detailRow}>
                          <span style={styles.detailLabel}>Chassi:</span>
                          <span style={styles.detailValue}>{veiculo.chassi}</span>
                        </div>
                      )}
                      {veiculo.motor && (
                        <div style={styles.detailRow}>
                          <span style={styles.detailLabel}>Nº do motor:</span>
                          <span style={styles.detailValue}>{veiculo.motor}</span>
                        </div>
                      )}
                      {veiculo.observacao && (
                        <div style={styles.detailRow}>
                          <span style={styles.detailLabel}>Obs:</span>
                          <span style={styles.detailValue}>{veiculo.observacao}</span>
                        </div>
                      )}
                    </div>
                    <div style={styles.veiculoActions}>

                      <button
                        onClick={() => abrirModalVeiculo(veiculo)}
                        style={styles.editButton}
                        disabled={loading}
                      >
                        <FaEdit /> Editar
                      </button>
                      <button
                        onClick={() => removerVeiculo(veiculo.idVeiculo)}
                        style={styles.deleteButton}
                        disabled={loading}
                      >
                        <FaTrash /> Remover
                      </button>

                      <DocumentButton
                        veiculo={veiculo}
                        onClick={() => {
                          setVeiculoArquivos(veiculo);
                          setShowFileModal(true);
                          fetchFiles(veiculo.idVeiculo);
                        }}
                      />

                      {/* ── NOVO: histórico de processos do veículo */}
                      <BotaoProcessos tipo="veiculo" id={veiculo.idVeiculo} titulo={veiculo.placa || veiculo.chassi} />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={styles.noResults}>
                Nenhum veículo cadastrado para este cliente
              </div>
            )}
          </div>
        ) : (
          <div style={styles.noResults}>
            {loading ? 'Carregando...' : 'Nenhum cliente selecionado. Use o botão "Selecionar Cliente" para começar.'}
          </div>
        )}

        {/* Modal de Pesquisa */}
        {modalPesquisaAberto && (
          <div style={styles.modalOverlay}>
            <div style={styles.modal}>
              <div style={styles.modalHeader}>
                <h2 style={styles.modalTitle}>Pesquisar Clientes</h2>
                <button
                  onClick={() => setModalPesquisaAberto(false)}
                  style={styles.modalClose}
                  disabled={loading}
                >
                  &times;
                </button>
              </div>
              <div style={styles.modalContent}>
                <div style={styles.searchBox}>
                  <input
                    type="text"
                    value={termoPesquisa}
                    onChange={(e) => setTermoPesquisa(e.target.value)}
                    placeholder="Digite nome ou CPF/CNPJ ou placa do veículo do cliente"
                    style={styles.searchInput}
                    onKeyPress={(e) => e.key === 'Enter' && executarPesquisa()}
                    disabled={loading}
                  />
                  <button
                    onClick={executarPesquisa}
                    style={styles.primaryButton}
                    disabled={loading}
                  >
                    <FaSearch /> {loading ? 'Pesquisando...' : 'Pesquisar'}
                  </button>
                </div>

                {loading ? (
                  <div style={styles.loading}>Carregando...</div>
                ) : resultadosPesquisa.length > 0 ? (
                  <div style={styles.resultsTable}>
                    <table style={styles.table}>
                      <thead>
                        <tr>
                          <th style={styles.th}>Nome</th>
                          <th style={styles.th}>CPF/CNPJ</th>
                          <th style={styles.th}>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {resultadosPesquisa.map((item, index) => (
                          <tr key={index} style={styles.tr}>
                            <td style={styles.td}>{item.dados.nome}</td>
                            <td style={styles.td}>{item.dados.cpfCnpj}</td>
                            <td style={styles.td}>
                              <button
                                onClick={() => selecionarCliente(item)}
                                style={styles.smallButton}
                                disabled={loading}
                              >
                                Selecionar
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : termoPesquisa ? (
                  <div style={styles.noResults}>Nenhum cliente encontrado</div>
                ) : (
                  <div style={styles.noResults}>Digite um termo para pesquisar</div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Modal de busca por placa ou chassi */}
        {modalPlacaAberto && (
          <div style={styles.modalOverlay}>
            <div style={{ ...styles.modal, maxWidth: '560px' }}>
              <div style={styles.modalHeader}>
                <h2 style={styles.modalTitle}>Pesquisar por Placa ou Chassi</h2>
                <button onClick={fecharBuscaPlaca} style={styles.modalClose} disabled={loading}>&times;</button>
              </div>
              <div style={styles.modalContent}>
                <div style={styles.searchBox}>
                  <input
                    type="text"
                    value={termoPlaca}
                    onChange={(e) => { setTermoPlaca(e.target.value.toUpperCase()); setVeiculoAchado(undefined); }}
                    placeholder="Placa (ABC1D23 ou ABC-1234) ou chassi"
                    style={styles.searchInput}
                    onKeyPress={(e) => e.key === 'Enter' && buscarPorPlacaOuChassi()}
                    disabled={loading}
                    autoFocus
                  />
                  <button onClick={buscarPorPlacaOuChassi} style={styles.primaryButton} disabled={loading}>
                    <FaSearch /> {loading ? 'Pesquisando...' : 'Pesquisar'}
                  </button>
                </div>

                {veiculoAchado === null && (
                  <div style={styles.noResults}>Nenhum veículo encontrado com essa placa ou chassi.</div>
                )}
                {veiculoAchado && (
                  <div style={styles.veiculoAchado}>
                    <FaCar style={{ ...styles.veiculoIcon, fontSize: 22 }} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <strong>{veiculoAchado.placa || 'Sem placa'}</strong>
                      {veiculoAchado.marcaModelo ? ` · ${veiculoAchado.marcaModelo}` : ''}
                      <div style={styles.veiculoAchadoDetalhe}>Chassi: {veiculoAchado.chassi || '—'}</div>
                      <div style={styles.veiculoAchadoDetalhe}>
                        Cliente: {veiculoAchado.idCliente ? (veiculoAchado.nomeCliente || 'cadastrado') : 'sem cliente vinculado'}
                      </div>
                    </div>
                    {veiculoAchado.idCliente && (
                      <button onClick={abrirVeiculoAchado} style={styles.smallButton} disabled={loading}>
                        Abrir cliente
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Modal de Veículo */}
        {modalVeiculoAberto && (
          <div style={styles.modalOverlay}>
            <div style={styles.modal}>
              <div style={styles.modalHeader}>
                <h2 style={styles.modalTitle}>
                  {veiculoEditando ? 'Editar Veículo' : 'Adicionar Veículo'} - {clienteSelecionado?.nome}
                </h2>
                <button
                  onClick={() => setModalVeiculoAberto(false)}
                  style={styles.modalClose}
                  disabled={loading}
                >
                  &times;
                </button>
              </div>
              <div style={styles.modalContent}>
                {/* O nº do motor só é aproveitado aqui, que é onde o cadastro do veículo o guarda */}
                <ImportarDocumento
                  tipo="veiculo"
                  importacao={importacaoVeiculo}
                  onImportacaoChange={setImportacaoVeiculo}
                  onDadosLidos={aplicarDadosVeiculo}
                  campos={['placa', 'renavam', 'chassi', 'motor', 'marcaModelo', 'cor', 'ano']}
                  disabled={loading}
                />
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Placa*</label>
                  <InputMask
                    name="placa"
                    value={formVeiculo.placa}
                    onChange={handlePlacaChange}
                    onBlur={() => {
                      if (formVeiculo.placa && formVeiculo.placa.length < 8) {
                        setErrors(prev => ({
                          ...prev,
                          placa: 'Placa incompleta'
                        }));
                      }
                    }}
                    placeholder="AAA-0000"
                    disabled={loading}
                    maxLength={8}
                    style={{
                      ...styles.input,
                      ...(errors.placa && styles.inputError),
                      ...(formVeiculo.placa.length === 8 && !errors.placa && { borderColor: '#2ecc71' })
                    }}
                  />
                  {errors.placa && (
                    <span style={styles.errorText}>
                      {errors.placa}
                      {errors.placa === PLACA_JA_DO_CLIENTE && veiculoJaDoCliente && (
                        <div style={{ marginTop: '8px', display: 'flex', gap: '8px' }}>
                          <button
                            type="button"
                            onClick={editarVeiculoJaCadastrado}
                            style={styles.primaryActionButton}
                          >
                            <FaEdit /> Editar o veículo cadastrado
                          </button>
                        </div>
                      )}
                      {errors.placa.includes('já está cadastrada') && (
                        <div style={{ marginTop: '8px', display: 'flex', gap: '8px' }}>
                          <button
                            onClick={() => handleReassignVehicle(null)}
                            style={styles.primaryActionButton}
                          >
                            <FaExchangeAlt /> Transferir para este cliente
                          </button>
                        </div>
                      )}
                    </span>
                  )}
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Marca/Modelo*</label>
                  <input
                    name="marcaModelo"
                    value={formVeiculo.marcaModelo}
                    onChange={handleVeiculoChange}
                    placeholder="Ex.: FORD FOCUS HC FLEX"
                    disabled={loading}
                    style={{ ...styles.input, ...(errors.marcaModelo && styles.inputError) }}
                  />
                  {errors.marcaModelo && <span style={styles.errorText}>{errors.marcaModelo}</span>}
                </div>
                <div style={styles.modalGrid}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Cor</label>
                    <input
                      name="cor"
                      value={formVeiculo.cor}
                      onChange={handleVeiculoChange}
                      placeholder="Ex.: CINZA"
                      disabled={loading}
                      style={styles.input}
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Ano</label>
                    <input
                      name="ano"
                      value={formVeiculo.ano}
                      onChange={handleVeiculoChange}
                      placeholder="Ex.: 2020/2021"
                      disabled={loading}
                      style={styles.input}
                    />
                  </div>
                </div>
                <div style={styles.modalGrid}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>RENAVAM</label>
                    <input
                      name="renavam"
                      value={formVeiculo.renavam}
                      onChange={handleVeiculoChange}
                      placeholder="Ex.: 123456789"
                      disabled={loading}
                      style={styles.input}
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Chassi</label>
                    <input
                      name="chassi"
                      value={formVeiculo.chassi}
                      onChange={handleVeiculoChange}
                      placeholder="Ex.: 9BWZZZ377VT004251"
                      disabled={loading}
                      style={{ ...styles.input, textTransform: 'uppercase' }}
                    />
                  </div>
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Nº do Motor</label>
                  <input
                    name="motor"
                    value={formVeiculo.motor}
                    onChange={handleVeiculoChange}
                    placeholder="Opcional. Ex.: KC16E8E496792"
                    disabled={loading}
                    style={{ ...styles.input, textTransform: 'uppercase' }}
                  />
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Observações</label>
                  <input
                    name="observacao"
                    value={formVeiculo.observacao}
                    onChange={handleVeiculoChange}
                    placeholder="Ex.: LIC 2025 OK"
                    disabled={loading}
                    style={styles.input}
                  />
                </div>

                <div style={styles.modalContent}>
                  {/* Seção atual do formulário de veículo (mantida igual) */}
                  {/* ... */}

                  {/* Nova seção de Licenciamentos */}
                  <div style={styles.section}>
                    <h3 style={styles.sectionTitle}>Licenciamentos do Veículo</h3>

                    {/* Tabela de licenciamentos */}
                    <div style={styles.tableContainer}>
                      <table style={styles.table}>
                        <thead>
                          <tr>
                            <th style={styles.tableHeader}>Ano</th>
                            <th style={styles.tableHeader}>Ações</th>
                          </tr>
                        </thead>
                        <tbody>
  {formVeiculo.licenciamentos?.length > 0 ? (
    formVeiculo.licenciamentos.map((licenciamento, index) => (
      <tr key={index} style={index % 2 === 0 ? styles.tableRow : styles.tableRowAlt}>
        <td style={styles.tableCell}>{licenciamento.ano}</td>
        <td style={styles.tableCellButtons}>
          {/* Botão Editar com Tooltip */}
          <button
            onClick={() => handleEditarLicenciamento(index)}
            style={styles.editIconButton}
            data-tooltip-id="edit-tooltip"
            data-tooltip-content="Editar licenciamento"
          >
            <FaEdit style={styles.editIcon} />
          </button>

          {/* Botão Excluir com Tooltip */}
          <button
            onClick={() => handleExcluirLicenciamento(index)}
            style={styles.deleteIconButton}
            data-tooltip-id="delete-tooltip"
            data-tooltip-content="Excluir licenciamento"
          >
            <FaTrash style={styles.deleteIcon} />
          </button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="2" style={styles.tableCell}>
        <div style={styles.noLicenciamentos}>
          <FaInfoCircle style={styles.infoIcon} />
          Nenhum licenciamento cadastrado
        </div>
      </td>
    </tr>
  )}
</tbody>
                      </table>
                    </div>

                    {/* Formulário para adicionar novo licenciamento */}
                    <div style={styles.addLicenciamentoForm}>
                      <input
                        type="text"
                        value={novoLicenciamento}
                        onChange={(e) => setNovoLicenciamento(e.target.value)}
                        placeholder="Digite o ano do licenciamento (ex: 2024)"
                        style={styles.input}
                      />
                      <button
                        onClick={handleAdicionarLicenciamentoLocal}
                        style={styles.primaryButton}
                        disabled={!novoLicenciamento || loading}
                      >
                        <FaPlus /> Adicionar Licenciamento
                      </button>
                    </div>
                  </div>
                </div>

              </div>
              <div style={styles.modalFooter}>
                <button
                  onClick={() => setModalVeiculoAberto(false)}
                  style={styles.secondaryButton}
                  disabled={loading}
                >
                  Cancelar
                </button>
                <button
                  onClick={salvarVeiculo}
                  style={styles.primaryButton}
                  disabled={loading}
                >
                  {loading ? 'Processando...' : (
                    <>
                      {veiculoEditando ? <FaEdit /> : <FaPlus />}
                      {veiculoEditando ? 'Atualizar Veículo' : 'Adicionar Veículo'}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
        <ConfirmModal
          isOpen={confirmModal.isOpen}
          onClose={closeConfirm}
          onConfirm={confirmModal.onConfirm}
          title={confirmModal.title}
          message={confirmModal.message}
          confirmText={confirmModal.confirmText}
          cancelText="Cancelar"
        />
      </div>
    </div>
  );
}


// Estilos completos
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    color: '#333',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  },

  content: {
    padding: '16px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
    width: '100%'
  },

  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
    flexWrap: 'wrap',
    gap: '12px'
  },

  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #ddd',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  titleIcon: {
    fontSize: '24px',
    color: '#333',
  },
  title: {
    fontSize: '20px',
    margin: 0,
    color: '#333',
  },
  importarDocumento: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
    marginBottom: '16px',
  },
  linkButton: {
    background: 'none',
    border: 'none',
    color: '#007bff',
    cursor: 'pointer',
    padding: 0,
    textDecoration: 'underline',
    fontSize: 'inherit',
  },
  cnpjRow: {
    display: 'flex',
    gap: '8px',
    alignItems: 'stretch',
  },
  cnpjButton: {
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    padding: '0 14px',
    borderRadius: '4px',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
  },
  cnpjButtonDisabled: {
    backgroundColor: '#b8c2cc',
    cursor: 'not-allowed',
  },
  searchButton: {
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    fontSize: '14px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  formContainer: {
    backgroundColor: 'white',
    padding: '16px 20px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    marginBottom: '20px'
  },

  formHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px',
    flexWrap: 'wrap',
    gap: '10px'
  },

  edicaoBadge: {
    backgroundColor: '#FFF9C4',
    color: '#F57F17',
    padding: '6px 12px',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: '600'
  },

  formRow: {
    display: 'flex',
    gap: '16px',
    marginBottom: '10px',
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      gap: '16px'
    }
  },

  inputGroup: {
    flex: '1',
    minWidth: '0',
    marginBottom: '0'
  },

  label: {
    display: 'block',
    marginBottom: '2px',
    fontWeight: '600',
    fontSize: '13px',
    color: '#34495e'
  },

  input: {
    width: '100%',
    padding: '8px 8px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    marginTop: '2px',
    transition: 'border 0.3s',
    '&:focus': {
      borderColor: '#3498db',
      outline: 'none'
    }
  },

  maskedInput: {
    width: '100%',
    padding: '8px 8px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    marginTop: '2px',
    transition: 'border 0.3s',
    '&:focus': {
      borderColor: '#3498db',
      outline: 'none'
    }
  },

  errorText: {
    color: '#e74c3c',
    fontSize: '12px',
    marginTop: '4px',
    display: 'block'
  },

  hintText: {
    color: '#7f8c8d',
    fontSize: '12px',
    marginTop: '4px',
    display: 'block',
    fontStyle: 'italic'
  },

  checkboxGroup: {
    display: 'flex',
    alignItems: 'center',
    margin: '8px 0 12px 0'
  },

  checkboxLabel: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    cursor: 'pointer'
  },

  checkbox: {
    marginRight: '8px',
    cursor: 'pointer'
  },

  primaryButton: {
    padding: '10px 16px',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontWeight: '600',
    transition: 'background-color 0.3s',
    backgroundColor: '#2ecc71',
    '&:hover': {
      backgroundColor: '#27ae60'
    },
    '&:disabled': {
      backgroundColor: '#95a5a6',
      cursor: 'not-allowed'
    }
  },

  secondaryButton: {
    padding: '10px 16px',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontWeight: '600',
    transition: 'background-color 0.3s',
    backgroundColor: '#95a5a6',
    '&:hover': {
      backgroundColor: '#7f8c8d'
    },
    '&:disabled': {
      backgroundColor: '#95a5a6',
      cursor: 'not-allowed'
    }
  },

  editButton: {
    padding: '8px 12px',
    backgroundColor: '#3498db',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px',
    fontWeight: '600',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: '#2980b9'
    }
  },

  deleteButton: {
    padding: '8px 12px',
    backgroundColor: '#e74c3c',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px',
    fontWeight: '600',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: '#c0392b'
    }
  },

  actionButton: {
    padding: '8px 12px',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px',
    fontWeight: '600',
    transition: 'background-color 0.3s'
  },

  clienteCard: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    overflow: 'hidden'
  },

  clienteHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    backgroundColor: '#f8f9fa',
    borderBottom: '1px solid #eee',
    flexWrap: 'wrap',
    gap: '12px'
  },

  clienteInfo: {
    flex: '1',
    minWidth: '200px'
  },

  clienteNome: {
    fontSize: '16px',
    margin: '0 0 4px 0',
    fontWeight: '600',
    color: '#2c3e50'
  },

  clienteDocumento: {
    fontSize: '14px',
    color: '#7f8c8d',
    display: 'block',
    marginBottom: '4px'
  },

  statusBadge: (ativo) => ({
    padding: '4px 8px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '600',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    backgroundColor: ativo ? '#E8F5E9' : '#FFEBEE',
    color: ativo ? '#2E7D32' : '#C62828'
  }),

  clienteActions: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap'
  },

  veiculosHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
    borderBottom: '1px solid #eee'
  },

  veiculosTitle: {
    fontSize: '16px',
    margin: '0',
    color: '#2c3e50'
  },

  veiculosContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '16px',
    padding: '16px'
  },

  veiculoCard: {
    backgroundColor: '#f9f9f9',
    borderRadius: '6px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    overflow: 'hidden'
  },

  // Veículo achado pela busca por placa/chassi: destaque por alguns segundos
  veiculoDestacado: {
    boxShadow: '0 0 0 3px #20b2aa, 0 4px 14px rgba(0,128,128,0.35)',
    transition: 'box-shadow 0.4s ease',
  },

  veiculoAchado: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 14px',
    border: '1px solid rgba(0,128,128,0.25)',
    borderRadius: '8px',
    background: '#f0fdfa',
    fontSize: '14px',
  },

  veiculoAchadoDetalhe: {
    fontSize: '12.5px',
    color: '#7f8c8d',
    marginTop: '2px',
  },

  veiculoHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    backgroundColor: '#f1f8fe'
  },

  veiculoIcon: {
    fontSize: '18px',
    color: '#e74c3c',
    marginRight: '10px'
  },

  veiculoInfo: {
    flex: '1'
  },

  veiculoModelo: {
    fontSize: '14px',
    margin: '0 0 2px 0',
    fontWeight: '600',
    color: '#34495e'
  },

  veiculoPlaca: {
    fontSize: '13px',
    color: '#7f8c8d',
    display: 'block'
  },

  veiculoDetails: {
    padding: '12px 16px'
  },

  detailRow: {
    display: 'flex',
    marginBottom: '8px',
    '&:lastChild': {
      marginBottom: '0'
    }
  },

  detailLabel: {
    flex: '0 0 80px',
    fontSize: '13px',
    color: '#7f8c8d',
    fontWeight: '500'
  },

  detailValue: {
    flex: '1',
    fontSize: '13px',
    fontWeight: '500'
  },

  veiculoActions: {
    display: 'flex',
    padding: '8px',
    borderTop: '1px solid #eee',
    gap: '8px',
    flexWrap: 'wrap'
  },

  loading: {
    textAlign: 'center',
    padding: '40px',
    color: '#7f8c8d'
  },

  noResults: {
    textAlign: 'center',
    padding: '40px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    color: '#7f8c8d'
  },

  modalOverlay: {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '1000'
  },

  modal: {
    backgroundColor: 'white',
    borderRadius: '8px',
    width: '90%',
    maxWidth: '800px',
    maxHeight: '90vh',
    overflowY: 'auto',
    boxShadow: '0 5px 15px rgba(0,0,0,0.3)'
  },

  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px',
    borderBottom: '1px solid #eee'
  },

  modalTitle: {
    fontSize: '18px',
    margin: '0',
    color: '#2c3e50'
  },

  modalClose: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#7f8c8d'
  },

  modalContent: {
    padding: '16px'
  },

  modalGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr'
    }
  },

  modalFooter: {
    padding: '16px',
    borderTop: '1px solid #eee',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px'
  },

  searchBox: {
    display: 'flex',
    gap: '10px',
    marginBottom: '20px'
  },

  searchInput: {
    flex: '1',
    padding: '10px 15px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '16px',
    '&:focus': {
      borderColor: '#3498db',
      outline: 'none'
    }
  },

  resultsTable: {
    width: '100%',
    overflowX: 'auto',
    marginBottom: '20px'
  },

  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px'
  },

  th: {
    backgroundColor: '#f8f9fa',
    padding: '12px 15px',
    textAlign: 'left',
    borderBottom: '1px solid #ddd',
    fontWeight: '600',
    position: 'sticky',
    top: '0'
  },

  tr: {
    borderBottom: '1px solid #eee',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  },

  td: {
    padding: '12px 15px',
    verticalAlign: 'middle'
  },

  smallButton: {
    padding: '6px 12px',
    backgroundColor: '#2ecc71',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '13px',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: '#27ae60'
    }
  },
  section: {
    marginTop: '20px',
    paddingTop: '20px',
    borderTop: '1px solid #eee'
  },
  sectionTitle: {
    fontSize: '18px',
    marginBottom: '15px',
    color: '#333'
  },
  tableContainer: {
    overflowX: 'auto',
    marginBottom: '20px'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: '15px'
  },
  tableHeader: {
    backgroundColor: '#f5f5f5',
    padding: '10px',
    textAlign: 'left',
    borderBottom: '1px solid #ddd'
  },
  tableRow: {
    backgroundColor: '#fff'
  },
  tableRowAlt: {
    backgroundColor: '#f9f9f9'
  },
  tableCell: {
    padding: '10px',
    borderBottom: '1px solid #eee'
  },
  tableCellButtons: {
    padding: '10px',
    borderBottom: '1px solid #eee',
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  
  // Botão de Editar
  editIconButton: {
    padding: '8px',
    margin: '0',
    cursor: 'pointer',
    backgroundColor: '#e3f2fd',
    border: '1px solid #bbdefb',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '36px',
    height: '36px',
    transition: 'all 0.3s ease',
    position: 'relative',
    '&:hover': {
      backgroundColor: '#bbdefb',
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 4px rgba(33, 150, 243, 0.3)'
    },
    '&:active': {
      transform: 'translateY(0)'
    }
  },
  
  editIcon: {
    fontSize: '14px',
    color: '#1976d2'
  },
  
  // Botão de Excluir
  deleteIconButton: {
    padding: '8px',
    margin: '0',
    cursor: 'pointer',
    backgroundColor: '#ffebee',
    border: '1px solid #ffcdd2',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '36px',
    height: '36px',
    transition: 'all 0.3s ease',
    position: 'relative',
    '&:hover': {
      backgroundColor: '#ffcdd2',
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 4px rgba(244, 67, 54, 0.3)'
    },
    '&:active': {
      transform: 'translateY(0)'
    }
  },
  
  deleteIcon: {
    fontSize: '14px',
    color: '#d32f2f'
  },
  
  // Estilo para quando não há licenciamentos
  noLicenciamentos: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#666',
    fontSize: '14px',
    fontStyle: 'italic'
  },
  
  infoIcon: {
    fontSize: '14px',
    color: '#2196f3'
  },
  
  smallButton: {
    padding: '5px 8px',
    margin: '0 3px',
    fontSize: '12px',
    cursor: 'pointer',
    backgroundColor: '#f0f0f0',
    border: '1px solid #ddd',
    borderRadius: '3px'
  },
  deleteButton: {
    backgroundColor: '#ffebee',
    borderColor: '#ef9a9a'
  },
  addLicenciamentoForm: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center'
  },
  fileModal: {
    backgroundColor: 'white',
    borderRadius: '8px',
    width: '90%',
    maxWidth: '800px',
    maxHeight: '90vh',
    overflowY: 'auto',
    boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
    display: 'flex',
    flexDirection: 'column'
  },

  fileModalHeader: {
    padding: '20px',
    borderBottom: '1px solid #eee',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#f8f9fa',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px'
  },

  fileModalTitle: {
    margin: 0,
    fontSize: '20px',
    color: '#333',
    fontWeight: '600'
  },

  fileModalCloseButton: {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#777',
    '&:hover': {
      color: '#333'
    }
  },

  fileModalBody: {
    padding: '20px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  },

  uploadSection: {
    padding: '20px',
    backgroundColor: '#f8f9fa',
    borderRadius: '6px',
    border: '1px dashed #ddd'
  },

  fileInput: {
    display: 'none'
  },

  uploadButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 15px',
    backgroundColor: '#e9ecef',
    border: '1px solid #ced4da',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s',
    '&:hover': {
      backgroundColor: '#dee2e6'
    }
  },

  fileInfo: {
    marginTop: '15px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexWrap: 'wrap'
  },

  fileNameText: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#333'
  },

  confirmButton: {
    padding: '8px 16px',
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: '500',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#218838'
    },
    '&:disabled': {
      backgroundColor: '#6c757d',
      cursor: 'not-allowed'
    }
  },

  progressBar: {
    marginTop: '15px',
    width: '100%',
    height: '20px',
    backgroundColor: '#e9ecef',
    borderRadius: '4px',
    overflow: 'hidden',
    position: 'relative'
  },

  progressText: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: 'white',
    fontSize: '12px',
    fontWeight: 'bold'
  },

  errorMessage: {
    marginTop: '10px',
    color: '#dc3545',
    fontSize: '14px',
    padding: '8px',
    backgroundColor: '#ffebee',
    borderRadius: '4px'
  },

  fileListSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },

  fileList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },

  fileItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 15px',
    backgroundColor: '#fff',
    border: '1px solid #eee',
    borderRadius: '6px',
    transition: 'all 0.2s',
    '&:hover': {
      backgroundColor: '#f8f9fa',
      borderColor: '#ddd'
    }
  },

  fileName: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flex: 1
  },

  fileDate: {
    fontSize: '12px',
    color: '#6c757d',
    marginTop: '4px'
  },

  fileActions: {
    display: 'flex',
    gap: '8px'
  },

  downloadButton: {
    backgroundColor: '#17a2b8',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#138496'
    }
  },

  deleteButton: {
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: '#c82333'
    }
  },

  noFiles: {
    textAlign: 'center',
    padding: '20px',
    color: '#6c757d',
    fontSize: '14px',
    backgroundColor: '#f8f9fa',
    borderRadius: '6px'
  },
  primaryActionButton: {
    padding: '6px 12px',
    backgroundColor: '#3498db',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: '#2980b9'
    }
  }
};

export default Clientes;
